import { TDashboardComponent } from "MyDashboards/components/ComponentRegistry/types";
import { Element } from "MyDashboards/state/editorTypes";
import React from "react";
import { ReactComponent as ChartPlaceholder } from "../../../../assets/chart-placeholder.svg";
const thumbNailRender = ({ el }: { el: Element }) => {
  return <ChartPlaceholder width={el.width} height={el.height} />;
};

const PreviewImage: TDashboardComponent = {
  editorMode: "image",
  Edit: () => <div />,
  Render: thumbNailRender,
};
export default PreviewImage;
